/** Single vertical for this SPA — do not branch to grocery/restaurant here. */
export const PHARMACY_VERTICAL = 'PHARMACY';
export const PHARMACY_CATALOG_KIND = 'pharmacy';
